module.exports = __webpack_public_path__ + "static/media/si.87f8906e.svg";